<template>
  <div class="home">
    <div class="data-table" id="orders-table" v-if="tasks">
      <div class="header">
        <div>ID</div>
        <div>Skill</div>
        <div>Worker</div>
        <div>Client</div>
        <div>Created At</div>
        <div>Status</div>
        <div>TTO</div>
      </div>
      <div
        v-for="task in tasks"
        v-bind:key="task.id"
        class="row"
      >
        <div class="cell" style="font-size: 14px;padding:3px 5px 0px 5px;">
          {{task.id}}<br />
          {{task.orderId}}
        </div>
        <div class="cell">
          {{task.skillId}}
        </div>
        <div class="cell">
          {{task.workerId}}
        </div>
        <div class="cell">
          {{task.clientId}}
        </div>
        <div class="cell">
          {{new Date(task.createdAt._seconds * 1000).toLocaleDateString() + ' ' + new Date(task.createdAt._seconds * 1000).getHours() + ':' + new Date(task.createdAt._seconds * 1000).getMinutes()}}
        </div>
        <div class="cell">
          {{task.status}}
        </div>
        <div class="cell">
          {{timeDiff(((task.notifications || {})[task.workerId] || {}).firstTimeOpenedAt, task.createdAt)}}
        </div>
      </div>
    </div>
    <!-- <img alt="Vue logo" src="../assets/logo.png"> -->
    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
  </div>
</template>

<style scoped lang="less">
#orders-table {
  grid-template-columns: auto auto auto auto auto auto auto;
  .row.finished .cell {
    color: #aaa;
  }
}
.link {
  align-self: center;
}
</style>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import api from "../services/api";
import * as storeReader from "../services/storeReader";

export default {
  name: "home",
  data: function() {
    return {
      storeReader,
      tasks: false,
    };
  },
  created: async function() {
    console.log('1');
    this.tasks = (await api.getTasks());
    console.log('2');
    this.tasks = this.tasks.filter(t => t.createdAt);
    console.log('3');
    this.tasks = this.tasks.sort((t1, t2) => {
      return t2.createdAt._seconds - t1.createdAt._seconds;
    });
    console.log('4');
    this.$forceUpdate();
    console.log('5');
    // console.log(this.orders.map((order, i) => ({...order, id: i})));
  },
  methods: {
    timeDiff(t1, t2) {
      if (t1 && t2) {
        const mins = Math.round((t1._seconds - t2._seconds) / 60 * 100) / 100;
        if (mins < 1800) {
          return mins + 'min.';
        }
      }
    }
  }
  // components: {
  //   HelloWorld
  // }
};
</script>
